import { theme } from '@noths/polaris-client-ribbons-base';
import { pxToRem } from '@noths/polaris-client-styles';
import { css } from 'styled-components';

const { spacing } = theme;

export const checkboxLabel = css`
  flex-direction: row;
  display: flex;
  cursor: pointer;
  color: var(--neutral-black-base);
`;

export const checkboxLabelDisabled = css`
  cursor: default;
  color: var(--neutral-black-40);
`;

export const checkboxErrorMessage = css`
  margin-left: ${pxToRem(4)};
`;

export const checkboxLabelText = css`
  align-self: center;
  flex-grow: 1;
  margin: ${spacing.base}px 0 0 ${spacing.xs}px;
`;
